// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vwkVN","col":"styles_col__3mbiC"};